import React from 'react';
import { Chip } from '@mui/material';

// Shown by both the receiver and the company detail views, which each list the users
// attached to what they are showing.
const renderUserChips = (userIds = [], getUserDisplayLabel) => {
    if (userIds.length === 0) {
        return <span className="empty-inline">Ingen brugere</span>;
    }

    return (
        <div className="user-chip-list">
            {userIds.map((userId) => (
                <Chip
                    key={userId}
                    size="small"
                    label={getUserDisplayLabel(userId)}
                    className="setup-chip"
                />
            ))}
        </div>
    );
};

export { renderUserChips };
